import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getCodBill = params => {
  return axios.request({
    url: "/finance/cod/branch/checkBill/ys",
    method: "get",
    params
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/${data.id}`,
    method: "put",
    data
  });
};

export const writeOff = (id, data) => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/writeOff/${id}`,
    method: "post",
    data
  });
};

export const batchWriteOff = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/batchWriteOff`,
    method: "post",
    data
  });
};

export const getListDetails = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/${id}`,
    method: "get"
  });
};

export const codConfirmBill = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/confirmed`,
    method: "post",
    data
  });
};

export const add = data => {
  return axios.request({
    url: "/finance/cod/branch/checkBill/ys",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const getCountryCurrency = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/totalCountryAndRate/${id}`,
    method: "get"
  });
};

export const codReStatistics = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/reStatistics/${data.id}`,
    method: "post",
    data
  });
};

export const getDetails = (id, params) => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/details/${id}`,
    method: "get",
    params
  });
};

export const del = (id, data) => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/removeDetail/${id}`,
    method: "delete",
    data
  });
};

export const exportBill = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/billDetailDaoChu/${id}`,
    method: "post"
  });
};

export const importBill = (id, data) => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/billDetailDaoRu/${id}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const delCod = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/${id}`,
    method: "delete"
  });
};
export const addCnbNo = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/appendToBill/${data.id}`,
    method: "post",
    data
  });
};

export const deleteShipment = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/moveOutBill/${data.id}`,
    method: "delete",
    data
  });
};

export const exportBillDetails = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/returnExport/${id}`,
    method: "get"
  });
};

export const cancelAgentOff = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/cancelAgentOff/${id}`,
    method: "post"
  });
};

export const cancelClientOff = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/cancelClientOff/${id}`,
    method: "post"
  });
};

export const checkClientAlipay = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/checkClientAlipay`,
    method: "post",
    data
  });
};

export const getExtFile = id => {
  return axios.request({
    url: `/finance/cod/extFile/read/${id}`,
    method: "get"
  });
};

export const uploadExtFile = (id, data) => {
  return axios.request({
    url: `/finance/cod/extFile/upload/${id}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};

export const delExtFile = (bill_id, id) => {
  return axios.request({
    url: `/finance/cod/extFile/del/${bill_id}/${id}`,
    method: "delete"
  });
};

export const saveExtFile = (id, data) => {
  return axios.request({
    url: `/finance/cod/extFile/save/${id}`,
    method: "post",
    data
  });
};

export const getAnalyze = params => {
  return axios.request({
    url: `/finance/bill_analyze/cod/analyze/${params.id}`,
    method: "get",
    params
  });
};

export const getBatchRate = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/batchTotalCountryAndRate`,
    method: "post",
    data
  });
};

export const saveBatchRate = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/batchReStatistics`,
    method: "post",
    data
  });
};

export const cancelConfirm = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/cancelConfirm`,
    method: "post",
    data
  });
};

export const waitOffBill = params => {
  return axios.request({
    url: `/finance/hedge/waitOffBill`,
    method: "get",
    params
  });
};

export const codDoHedge = data => {
  return axios.request({
    url: `/finance/hedge/codDoHedge`,
    method: "post",
    data
  });
};

export const changeBillHeader = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/changeBillHeader`,
    method: "post",
    data
  });
};

export const batchExportBillFiles = data => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/batchExportBillFiles`,
    method: "post",
    data
  });
};

export const setRate = data => {
  return axios.request({
    url: `/finance/hedge/setRate`,
    method: "post",
    data
  });
};

// 明细详情接口
export const getItemDetails = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/${id}`,
    method: "get"
  });
};

export const deleteItem = id => {
  return axios.request({
    url: `/finance/cod/branch/checkBill/ys/${id}`,
    method: "delete"
  });
};